<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="template !== null">

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.onlinetests') }}</h2>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <button withRight="admin.template.edit" *ngIf="items.length > 0 && optionsPartners.length > 0" pButton type="button" (click)="menu.toggle($event)" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-sm p-button-success p-mb-2 autofocus"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
        </div>
    </div>

    <p-table *ngIf="inEdit === true || template.onlinetests?.length > 0" [value]="template.onlinetests">
      <ng-template pTemplate="header">
        <tr>
            <th>{{ t('common.labels.onlinetest') }}</th>
            <th>{{ t('common.labels.type') }}</th>
            <th>{{ t('common.labels.forerun_duration') }}</th>
            <th>{{ t('common.labels.rating_duration') }}</th>
            <th>{{ t('common.labels.competences') }}</th>
            <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-onlinetest let-index="rowIndex">
        <tr *ngIf="(inEdit !== true || onlinetest !== editOnlinetest) && onlinetest.type !== 'normal'">
          <ng-template [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ onlinetest: onlinetest }"></ng-template>
        </tr>
        <tr *ngIf="(inEdit !== true || onlinetest !== editOnlinetest) && onlinetest.type === 'normal'" [pReorderableRow]="index">
          <ng-template [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ onlinetest: onlinetest }"></ng-template>
        </tr>
        <ng-container *ngIf="inEdit === true && editOnlinetest === onlinetest">
          <ng-template [ngTemplateOutlet]="tForm"></ng-template>
        </ng-container>
      </ng-template>

      <ng-template pTemplate="footer">
        <ng-container *ngIf="inEdit === true && editOnlinetest === null">
          <ng-template [ngTemplateOutlet]="tForm"></ng-template>
        </ng-container>
      </ng-template>
    </p-table>

    <!-- ROW TEMPLATE -->
    <ng-template #row let-onlinetest="onlinetest">
      <td>{{onlinetest.fullname}}</td>
      <td>
        {{t(onlinetest.getTypeName())}}
      </td>
      <td>
        <span *ngIf="onlinetest.type === 'normal'">
          {{onlinetest.duration}} {{ t('common.labels.minutes') }}
        </span>
        <span *ngIf="onlinetest.type === 'before'">
          {{onlinetest.unlock_days}} {{ t('common.labels.days') }}
        </span>
      </td>
      <td>
        <span *ngIf="onlinetest.type === 'normal' && onlinetest.rating_duration !== null">{{onlinetest.rating_duration}} {{ t('common.labels.minutes') }}</span>
      </td>
      <td>{{ onlinetest.competences.length - onlinetest.hidden_competences.length }}</td>
      <td style="text-align: right">
        <span withRight="admin.template.edit" *ngIf="inEdit !== true">
          <button pButton (click)="onEdit(onlinetest)" type="button" icon="pi pi-pencil"></button>
          <button pButton (click)="onDelete(onlinetest)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2" [disabled]="!onlinetest.pivot?.deletable"></button>
        </span>
      </td>
    </ng-template>
    <!-- ROW TEMPLATE -->

    <!-- FORM TEMPLATE -->
    <ng-template #tForm>
      <tr>
        <td>
          <div class="p-inputgroup" *ngIf="editType === 'normal' || editType === 'before'">
            <app-form-control *ngIf="editOnlinetest === null" [cid]="'onlinetest'" [control]="form.get('onlinetest')" [type]="'cascade'" [options]="optionsPartners" [optionLabel]="'name'" [optionGroupLabel]="'name'" [optionGroupChildren]="['onlinetests']" [label]="''"></app-form-control>
            <p *ngIf="editOnlinetest !== null">{{editOnlinetest.fullname}}</p>
          </div>
        </td>
        <td>
          {{t(typeNames[editType])}}
        </td>
        <td>
          <div class="p-inputgroup" *ngIf="editType === 'normal'">
            <p-inputNumber [formControl]="form.get('duration')" type="text" aria-describedby="duration-help" [showButtons]="true" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0" min="0" max="240"></p-inputNumber>
            <app-form-error [control]="form.get('duration')" [label]="t('common.labels.duration')"></app-form-error>
          </div>
          <div class="p-inputgroup" *ngIf="editType === 'before'">
            <p-inputNumber [formControl]="form.get('unlock_days')" type="text" aria-describedby="unlock_days-help" [showButtons]="true" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0" min="1" max="60"></p-inputNumber>
            <app-form-error [control]="form.get('unlock_days')" [label]="t('common.labels.forerun')"></app-form-error>
          </div>
        </td>
        <td>
          <div class="p-inputgroup" *ngIf="editType === 'normal'">
            <p-inputNumber [formControl]="form.get('rating_duration')" type="text" aria-describedby="rating_duration-help" [showButtons]="true" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0" min="0" max="240" step="5"></p-inputNumber>
            <app-form-error [control]="form.get('rating_duration')" [label]="t('common.labels.rating_duration')"></app-form-error>
          </div>
        </td>
        <td>
          <app-ac-competences [competences]="editCompetences" [hidden]="hiddenCompetences" (changed)="setHiddenCompetences($event)"></app-ac-competences>
        </td>
        <td style="text-align: right">
          <app-form-buttons [submitting]="submitting" [icons]="false" (cancelled)="onCancel()"></app-form-buttons>
        </td>
      </tr>
      <tr>
        <td colspan="5">
          <div class="p-grid">
            <div class="p-col">
              <app-form-control [cid]="'login_url'" [control]="form.get('login_url')" [type]="'input'" [label]="t('common.labels.login_url')"></app-form-control>
            </div>
            <div class="p-col">
              <app-form-control [cid]="'login_user'" [control]="form.get('login_user')" [type]="'input'" [label]="t('common.labels.login_user')"></app-form-control>
            </div>
            <div class="p-col">
              <app-form-control [cid]="'login_password'" [control]="form.get('login_password')" [type]="'input'" [label]="t('common.labels.login_password')"></app-form-control>
            </div>
            <div class="p-col">
              <app-form-control [cid]="'comment'" [control]="form.get('comment')" [type]="'input'" [label]="t('common.labels.comment')"></app-form-control>
            </div>
          </div>
        </td>
        <td></td>
      </tr>
    </ng-template>
    <!-- FORM TEMPLATE -->

    <p *ngIf="inEdit !== true && template.onlinetests?.length === 0">{{ t('common.texts.no_onlinetests') }}</p>

  </form>

  <app-inherit-dialog
    [title]="t('common.labels.delete')"
    [mode]="'template'"
    [(visible)]="deleteInheritVisible"
    (okClicked)="deleteOnlinetest($event)"
  ></app-inherit-dialog>

  <app-inherit-dialog
    [title]="t('common.labels.save')"
    [mode]="'template'"
    [(visible)]="saveInheritVisible"
    (okClicked)="saveOnlinetest($event)"
  ></app-inherit-dialog>

</ng-container>
